import { Navigate } from "react-router-dom";
import { useAdminRole } from "../../utils/useAdminRole";

/**
 * Route guard for super-admin-only screens (GAP-018). Mall admins that
 * deep-link into these routes are bounced to the dashboard; the backend
 * enforces the same boundary regardless.
 */
const RequireSuperAdmin = ({ children }) => {
  const { isSuperAdmin } = useAdminRole();

  if (!isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RequireSuperAdmin;
